"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getErrorDetails=e=>{if("object"==typeof e&&null!==e){return Object.keys(e).map((t=>e[t])).join("/n")}return e};
//# sourceMappingURL=utils.js.map
